var map = {
	"./about.svg": 236,
	"./address.svg": 3911,
	"./client.png": 8702,
	"./dot.svg": 6134,
	"./exit.png": 3419,
	"./menu.png": 5238,
	"./report.png": 1029,
	"./settings.png": 1164,
	"./support.png": 4790,
	"./user.png": 3970,
	"./zoom.png": 9330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2211;